import React from "react";
import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLazyGetMapViewQuery } from "../../../redux/mapView/mapViewAPI";
import GETJwtToken from "../../../redux/authentication/authentication";
import { updateMapViewItem } from "../../../redux/mapView/mapViewSlice";
import formatUuidT from "../../../flatbuffers/display/uuid";

function MonitoringMapViewList() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();
  const [triggerGetMapView, { data: dataGetMapView, isLoading: isLoadingGetMapView }] =
    useLazyGetMapViewQuery();

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { selectedOrganization, mapViewItem } = useSelector((state: any) => state.mapView);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const getInitialData = async () => {
    if (!selectedOrganization) {
      return;
    }
    const token = await GETJwtToken();
    const BODY: any = {
      org_id: selectedOrganization,
    };
    triggerGetMapView({
      token,
      body: BODY,
    });
  };

  // ************************************************ */
  // USE EFFECT ************************************* */
  React.useEffect(() => {
    getInitialData();
  }, [selectedOrganization]);

  // ************************************************ */
  // COMPONENT ************************************** */
  const mapRows = Array.isArray(dataGetMapView?.data) ? dataGetMapView.data : [];
  const selectedMapId = formatUuidT(mapViewItem?.id);
  const options = mapRows.map((item: any) => ({
    label: String(item?.name || "Unnamed map"),
    value: formatUuidT(item?.id),
  }));

  return (
    <Select
      value={selectedMapId || undefined}
      placeholder="Select a map"
      style={{ minWidth: 260 }}
      loading={isLoadingGetMapView}
      options={options}
      showSearch
      optionFilterProp="label"
      onChange={(value) => {
        const selected = mapRows.find((item: any) => formatUuidT(item?.id) === value);
        if (selected && formatUuidT(mapViewItem?.id) !== formatUuidT(selected?.id)) {
          dispatch(updateMapViewItem(selected));
        }
      }}
    />
  );
}

export default MonitoringMapViewList;
